import React from 'react'
import { BellIcon } from '@frontend/pole-ui/lib/components/Icon/svg/BellIcon'
import { CartIcon } from '@frontend/pole-ui/lib/components/Icon/svg/CartIcon'
import { ChatIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ChatIcon'
import { List1Icon } from '@frontend/pole-ui/lib/components/Icon/svg/List1Icon'
import { NewsTabIcon } from '@frontend/pole-ui/lib/components/Icon/svg/NewsTabIcon'
import { ShieldDoneIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ShieldDoneIcon'
import { WalletIcon } from '@frontend/pole-ui/lib/components/Icon/svg/WalletIcon'
import { WheatBoldIcon } from '@frontend/pole-ui/lib/components/Icon/svg/WheatBoldIcon'
import type { IGenerateMenuProps, NavLink } from '@/components/composed/MobileNavBar/interfaces'
import { ECommonRoute, EFinancingOfferRoute, EJournalRoute, EUserProfileRoute } from '@/types'
import { EOfferRequestsRoute } from '@/types/EOfferRequestsRoute'

export const generateMenu = ({
  isAuthenticated,
  isBuyer,
  isSupplier,
  isLogisticsOperator,
  notificationsCount,
}: IGenerateMenuProps): NavLink[] => {
  if (!isAuthenticated)
    return [
      {
        textId: 'offerRequests',
        url: EOfferRequestsRoute.main,
        icon: <WheatBoldIcon />,
      },
      {
        textId: 'tenders',
        url: ECommonRoute.tendersPublicList,
        icon: <CartIcon />,
      },
      {
        textId: 'credits',
        url: EFinancingOfferRoute.main,
        icon: <WalletIcon />,
      },
      {
        textId: 'news',
        url: EJournalRoute.MAIN,
        icon: <NewsTabIcon />,
      },
    ]

  if (isBuyer)
    return [
      {
        textId: 'requests',
        url: EUserProfileRoute.sales,
        icon: <List1Icon />,
      },
      {
        textId: 'documents',
        url: EUserProfileRoute.myDocuments,
        icon: <ShieldDoneIcon />,
      },
      {
        textId: 'notifications',
        url: EUserProfileRoute.notifications,
        icon: <BellIcon />,
        counter: notificationsCount.totalUnreadNotificationsCount,
      },
      {
        textId: 'chat',
        url: EUserProfileRoute.myChats,
        icon: <ChatIcon />,
        counter: notificationsCount.unreadChatMessagesCount,
      },
    ]

  if (isSupplier)
    return [
      {
        textId: 'orders',
        url: EUserProfileRoute.orders,
        icon: <CartIcon />,
      },
      {
        textId: 'notifications',
        url: EUserProfileRoute.notifications,
        icon: <BellIcon />,
        counter: notificationsCount.totalUnreadNotificationsCount,
      },
      {
        textId: 'chat',
        url: EUserProfileRoute.myChats,
        icon: <ChatIcon />,
        counter: notificationsCount.unreadChatMessagesCount,
      },
    ]

  if (isLogisticsOperator) return []

  return [
    {
      textId: 'offerRequests',
      url: EOfferRequestsRoute.main,
      icon: <WheatBoldIcon />,
    },
    {
      textId: 'tenders',
      url: ECommonRoute.tendersPublicList,
      icon: <CartIcon />,
    },
    {
      textId: 'credits',
      url: EFinancingOfferRoute.main,
      icon: <WalletIcon />,
    },
    {
      textId: 'deals',
      url: '',
      icon: <List1Icon />,
      additional: true,
    },
    {
      textId: 'chat',
      url: EUserProfileRoute.myChats,
      icon: <ChatIcon />,
      counter: notificationsCount.unreadChatMessagesCount,
    },
  ]
}
